<template>
  <div class="rui-modal">
    <rui-overlay />
    <div class="rui-modal__widget" :class="componentCSS">
      <div class="rui-modal__header">
        <h2>{{ caption }}</h2>
        <!--
          When modal is simply closed
          @event close
        -->
        <rui-button v-if="closeable"
                    icon="rui:x-bold"
                    text
                    :title="$t('rui.generic.close')"
                    @click="$emit('close')" />
      </div>
      <div class="rui-modal__content">
        <!-- @slot Modal content -->
        <slot />
      </div>
      <div v-if="!noFooter && (acceptable || cancellable)" class="rui-modal__footer">
        <!--
          When "cancel" button is pressed
          @event cancel
        -->
        <rui-button v-if="cancellable" variant="canceling" @click="$emit('cancel')">{{ $t('rui.generic.cancel') }}</rui-button>
        <!--
          When "OK" button is pressed
          @event accept
        -->
        <rui-button v-if="acceptable" variant="recording" @click="$emit('accept')">{{ $t('rui.generic.ok') }}</rui-button>
      </div>
    </div>
  </div>
</template>
<script>
import RuiOverlay from '../Utils/Overlay/Overlay.vue'
import RuiButton from '../Button/Button.vue'

/**
 * Modal component to display _things_ above the page content.
 *
 * Text content may be wrapped with a `._container`, as there is no padding for it.
 *
 * @noPlayground Some setup is needed to be able to show/hide the component
 * @propsGroup Display  [noFooter, large]
 * @propsGroup Behavior [closeable, acceptable, cancellable]
 * @propsGroup Content  [caption]
 */
export default {
  name: 'RuiModal',
  emits: [
    'close',
    'cancel',
    'accept',
  ],
  components: { RuiButton, RuiOverlay },
  props: {
    /** Modal title */
    caption: { required: true, type: String, default: null },
    /** Whether to add a "close" button */
    closeable: { required: false, type: Boolean, default: true },
    /** Whether to add an "Ok" button */
    acceptable: { required: false, type: Boolean, default: true },
    /** Whether to add a "Cancel" button */
    cancellable: { required: false, type: Boolean, default: false },
    /** Whether to hide the modal footer (accept/cancel actions) */
    noFooter: { required: false, type: Boolean, default: false },
    /** Whether the modal is larger */
    large: { required: false, type: Boolean, default: false },
  },
  computed: {
    componentCSS () {
      return [
        this.large && 'rui-modal__widget--large',
      ]
    },
  },
}
</script>
